export const NAV_BAT = [
  { id: 'accueil', icon: '🏠', label: 'Accueil' },
  { id: 'devis', icon: '📄', label: 'Devis' },
  { id: 'chantiers', icon: '🏗️', label: 'Chantiers' },
  { id: 'factures', icon: '🧾', label: 'Factures' },
  { id: 'plus', icon: '⋯', label: 'Plus' },
];

export const NAV_MAG = [
  { id: 'accueil', icon: '🏠', label: 'Accueil' },
  { id: 'ventes', icon: '🛒', label: 'Ventes' },
  { id: 'devis', icon: '📄', label: 'Offres' },
  { id: 'factures', icon: '🧾', label: 'Factures' },
  { id: 'plus', icon: '⋯', label: 'Plus' },
];

// L'ouvrier n'a pas d'accueil d'entreprise : son espace en tient lieu.
export const NAV_OUVRIER = [
  { id: 'ouvrier', icon: '⚒', label: 'Mon espace' },
  { id: 'plus', icon: '⋯', label: 'Plus' },
];
